import { ART } from "../assets";
import { Reveal } from "./Reveal";

const possibilities = [
  { from: "Garage", to: "Gym" },
  { from: "Basement", to: "Office" },
  { from: "Storage", to: "Playroom" },
  { from: "Workshop", to: "Studio" },
  { from: "Spare room", to: "Nursery" },
  { from: "Corner", to: "Reading room" },
];

export default function SpaceReclaimed() {
  return (
    <section id="spaces" className="relative py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <div className="order-2 lg:col-span-6 lg:order-2">
            <Reveal>
              <div className="overflow-hidden rounded-[2.5rem] bg-white/50">
                <img src={ART.spaceReclaimed} alt="A reclaimed, restful room" className="w-full" />
              </div>
            </Reveal>
          </div>

          <div className="order-1 lg:col-span-6 lg:order-1 lg:pr-10">
            <Reveal>
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-violet/70">
                Space reclaimed
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight text-charcoal sm:text-5xl lg:text-6xl text-balance">
                What could this room become?
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 max-w-md text-lg leading-relaxed text-charcoal/60">
                Behind every pile of clutter is a room waiting to be reborn. Clear
                the noise, and the possibility reveals itself.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <ul className="mt-10 divide-y divide-stone/70 border-y border-stone/70">
                {possibilities.map((p, i) => (
                  <li
                    key={p.to}
                    data-testid={`possibility-${i}`}
                    className="group flex items-baseline gap-4 py-4 transition-colors"
                  >
                    <span className="w-32 shrink-0 text-charcoal/45 line-through decoration-stone">
                      {p.from}
                    </span>
                    <span className="text-charcoal/30 transition-transform duration-300 group-hover:translate-x-1">→</span>
                    <span className="font-display text-2xl italic text-charcoal transition-colors duration-300 group-hover:text-violet">
                      {p.to}
                    </span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
